<template>
    <div>
        <el-form :inline="true">
            <el-form-item>
                <el-input
                        v-model="searchForm.name"
                        placeholder="模板名称"
                        clearable
                        style="width: 200px"
                >
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="getTemplateList">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="addTemplate">新增</el-button>
            </el-form-item>
        </el-form>

        <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                border
                stripe>
            <el-table-column
                    prop="name"
                    label="模板名称"
                    width="400">
            </el-table-column>
            <el-table-column
                    prop="content"
                    label="模板内容"
                    width="200">
                <template slot-scope="scope">
                    <el-tag size="small" type="success"><span @click="openPreview(scope.row.content)">HTML</span>
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column
                    prop="icon"
                    label="操作">

                <template slot-scope="scope">
                    <el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
                    <el-divider direction="vertical"></el-divider>

                    <template>
                        <el-popconfirm title="这是一段内容确定删除吗？" @confirm="delHandle(scope.row.id)">
                            <el-button type="text" slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>
                </template>
            </el-table-column>

        </el-table>

        <!--新增对话框-->
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                width="60%"
                :before-close="handleClose"
        >

            <el-form :model="editForm" :rules="editFormRules" ref="editForm">
                <el-form-item label="模板名称" prop="name" label-width="140px">
                    <el-input v-model="editForm.name" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="模板内容" prop="content" label-width="140px">
                    <UEditor ref="ue"></UEditor>
                    <span v-show="isErr" class="el-form-item__error">请输入模板内容</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('editForm')">取 消</el-button>
                <el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
                <el-button type="info" @click="onPreview()">预览</el-button>
            </div>
        </el-dialog>

        <!--预览弹框-->
        <el-dialog
                title="邮件内容预览"
                :visible.sync="previewVisible"
                width="40%">
            <div style="border: 2px solid;">
                <div style="margin: 10px" v-html="preview"></div>
            </div>
        </el-dialog>

    </div>
</template>


<script>
    import UEditor from '@/common/UEditor'

    export default {
        name: "Template",
        components: { UEditor },
        data() {
            return {
                previewVisible: false,
                preview: "",
                isErr: false,
                searchForm: {},
                dialogVisible: false,
                editForm: {
                  content: ''
                },
                tableData: [],
                editFormRules: {
                    name: [
                        {required: true, message: '请输入模板名称', trigger: 'blur'}
                    ]
                },
            }
        },
        created() {
            this.getTemplateList()
        },
        methods: {
            openUEditor(val) {
              this.$refs.ue.contents = val
            },
            onPreview() {
                this.previewVisible = true
                this.preview = this.$refs.ue.contents
            },
            openPreview(content) {
                this.previewVisible = true
                this.preview = content
            },
            resetForm(formName) {
                this.isErr = false
                this.$refs[formName].resetFields();
                this.dialogVisible = false
                this.editForm = {}
                this.openUEditor('')
            },
            handleClose() {
                this.resetForm('editForm')
                this.isErr = false
                this.openUEditor('')
            },
            addTemplate() {
                this.dialogVisible = true
                this.isErr = false
                this.openUEditor('')
            },
            getTemplateList() {
                this.$axios.get("/uxm/email-template/list", {
                    params: {
                        name: this.searchForm.name
                    }
                }).then(res => {
                    this.tableData = res.data.data
                })
            },
            submitForm(formName) {
                this.isErr = false
                if (this.$refs.ue.contents == '' || this.$refs.ue.contents == null) {
                    this.isErr = true
                }
                this.editForm.content = this.$refs.ue.contents
                this.$refs[formName].validate((valid) => {
                    if (valid && !this.isErr) {
                        this.$axios.post('/uxm/email-template/' + (this.editForm.id ? 'edit' : 'add'), this.editForm)
                            .then(res => {
                                this.$message({
                                    showClose: true,
                                    message: '恭喜你，操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.getTemplateList()
                                        this.isErr = false
                                    }
                                });

                                this.dialogVisible = false
                            })
                    } else {
                        return false;
                    }
                });
            },
            editHandle(id) {
                this.$axios.get('/uxm/email-template/info/' + id).then(res => {
                    this.editForm = res.data.data
                    this.dialogVisible = true
                    this.isErr = false
                    //this.$refs.ue.contents = res.data.data.content
                    this.openUEditor(res.data.data.content)
                })
            },
            delHandle(id) {
                this.$axios.get('/uxm/email-template/remove/' + id).then(res => {
                    this.$message({
                        showClose: true,
                        message: '恭喜你，操作成功',
                        type: 'success',
                        onClose: () => {
                            this.getTemplateList()
                        }
                    });
                })
            }
        }
    }
</script>

<style scoped>

    .el-pagination {
        float: right;
        margin-top: 22px;
    }

</style>
